export default __webpack_public_path__ + "static/media/phone.edd6e53f.svg";